import {
    DELETE_PRODUCT_RELATED,
    DELETE_PRODUCT_RELATED_FAILURE,
    DELETE_PRODUCT_RELATED_SUCCESS,
} from 'store/actions/types';

export const deleteProductRelated = (payload) => {
    return {
        type: DELETE_PRODUCT_RELATED,
        payload: payload,
    };
};

export const deleteProductRelatedFailure = (error) => {
    return {
        type: DELETE_PRODUCT_RELATED_FAILURE,
        error: error,
    };
};

export const deleteProductRelatedSuccess = (productId, productRelatedId) => {
    return {
        type: DELETE_PRODUCT_RELATED_SUCCESS,
        productId: productId,
        productRelatedId: productRelatedId,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/related/deleteProductRelated.js